<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      size="small"
      :rules="rules"
      :model="curdForm"
      label-position="right"
      label-width="100px"
    >
      <el-row>
        <el-col>
          <el-form-item label="学分年份：" prop="creditYear" required>
            <el-date-picker
              type="year"
              placeholder="请选择年份"
              v-model="curdForm.creditYear"
              format="yyyy"
              value-format="yyyy"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="addType == 0">
        <el-col>
          <el-form-item label="奖励学分：" prop="credit" required>
            <el-input-number
              v-model="curdForm.credit"
              :min="0"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="addType == 1">
        <el-col>
          <el-form-item label="惩罚学分：" prop="credit" required>
            <el-input-number
              v-model="curdForm.credit"
              :min="0"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="addType == 0">
        <el-col>
          <el-form-item label="奖励事项：" prop="reason" required>
            <el-input
              placeholder="请输入奖励事项"
              v-model="curdForm.reason"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="addType == 1">
        <el-col>
          <el-form-item label="惩罚事项：" prop="reason" required>
            <el-input
              placeholder="请输入惩罚事项"
              v-model="curdForm.reason"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="addType == 0">
        <el-col>
          <el-form-item label="奖励学员：" prop="userId" required>
            <el-input
              placeholder="请选择奖励学员"
              v-model="userName"
              suffix-icon="el-icon-plus"
              @click.native="memberSelect"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else-if="addType == 1">
        <el-col>
          <el-form-item label="惩罚学员：" prop="userId" required>
            <el-input
              placeholder="请选择惩罚学员"
              v-model="userName"
              suffix-icon="el-icon-plus"
              @click.native="memberSelect"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn title="取消" @click.native="closeFrom('curdForm')"></butn>
      <butn btntype="primary" title="确定" @click="submitForm"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import { rewardSave, punishmentSave } from "@/api/rewardPunish";
export default {
  components: { butn },
  data() {
    return {
      Bus,
      curdTitle: "",
      CUFlag: false,
      addType: 0,
      userName: "",
      curdForm: {
        creditDealType: 0,
        userId: "",
        creditYear: "",
        credit: "",
        reason: "",
        userIds: []
      },
      rules: {
        creditYear: [{ required: true, message: "学分年份不能为空" }],
        credit: [{ required: true, message: "奖惩学分不能为空" }],
        reason: [{ required: true, message: "奖惩事项不能为空" }],
        userId: [{ required: true, message: "奖惩学员不能为空" }]
      },
      props: {
        //树形
        label: "name",
        children: "children",
        value: "id"
      },
      command: function() {}
    };
  },
  created() {
    let _this = this;
    Bus.$on("ReceiveMessage", function(item) {
      // item=0奖励学分新增，item=1 惩罚学分新增
      _this.addType = item;
      _this.curdTitle = item === 0 ? "奖励学分" : "惩罚学分";
      _this.command = item === 0 ? rewardSave : punishmentSave;
      _this.CUFlag = true;
    });
    Bus.$on("addSucceed", function(item) {
      _this.curdForm.userIds = item.map(ele => ele.id);
      _this.userName = item[0].name;
      _this.curdForm.userId = item[0].id;
    });
  },
  methods: {
    //选择人员
    memberSelect() {
      Bus.$emit("selectMember", "");
    },
    submitForm() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = Object.assign({}, this.curdForm);
          params.creditDealType = this.addType;
          this.command(params)
            .then(res => {
              if (!res || res.code != 0) throw new Error(res.msg);
              this.$message.success(res.msg);
              this.CUFlag = false;
              this.$emit("search", {});
              params.userIds = [];
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    closeDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
      this.$refs["curdForm"].resetFields();
    },
    closeFrom() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.select-tree {
  width: 100%;
}
</style>
